import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const StyledText = styled.div(({ theme: { fontSize, colors } }) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: fontSize * 0.75,
  fontWeight: '700',
  lineHeight: `${fontSize}px`,
  color: colors.mid_grey,
}))

const ExpirationText = ({ children }) => (
  <StyledText data-test="ExpirationText">
    {children}
  </StyledText>
)

ExpirationText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
}

ExpirationText.defaultProps = {
  children: '',
}

ExpirationText.displayName = 'ExpirationText'
ExpirationText.whyDidYouRender = true

export default React.memo(ExpirationText)
